const handleize = (string: string) => {
  const parts = string.toLowerCase().split(' ').map((part) => (
    part.trim()
  ));

  return parts.join('-');
};

export default handleize;
